import React, { useState } from 'react'
import { Box, Button, Chip, Collapse, Tooltip } from '@mui/material'
import { KeyboardArrowUp, KeyboardArrowDown } from '@mui/icons-material'

import { useAppSelector } from 'redux/Hook'

interface Props {
  keyPhrases: string[]
}

export const CardKeyPhrases = ({ keyPhrases }: Props) => {
  const [open, setOpen] = useState(false)
  const { themes_keyphrasesToggle } = useAppSelector(
    (state: any) => state.textAnalysis.main.appConfig,
  )

  const handleClick = () => {
    setOpen(!open)
  }

  if (!keyPhrases.length || !themes_keyphrasesToggle) return null

  return (
    <Box
      data-testid="ta-card-key-phrases"
      sx={{
        ml: '0 !important',
        mt: 1.5,
        pt: 1,
        borderTop: 1,
        borderColor: 'grey.100',
        width: '100%',
      }}
    >
      <Button
        variant="text"
        size="small"
        onClick={handleClick}
        endIcon={
          open ? (
            <KeyboardArrowUp fontSize="small" />
          ) : (
            <KeyboardArrowDown fontSize="small" />
          )
        }
        sx={{ mb: 1, width: { xs: '100%', md: 'auto' } }}
      >
        Key Phrases
      </Button>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {keyPhrases.map((phrase) => {
            const isLongPhrase = phrase.length > 30
            const displayPhrase = isLongPhrase
              ? phrase.substring(0, 27) + '...'
              : phrase
            return (
              <Tooltip
                key={phrase}
                title={isLongPhrase ? phrase : ''}
                placement="top"
              >
                <Chip
                  size="small"
                  label={displayPhrase}
                  sx={{ bgcolor: 'grey.100' }}
                />
              </Tooltip>
            )
          })}
        </Box>
      </Collapse>
    </Box>
  )
}
